module.exports = __webpack_public_path__ + "static/backto-mobile-f8c77cc61e0955b5510c188e5f6c01f4.svg";